/**
 * Auto-granted 7-day Pro trial has been disabled.
 * Pro access now requires a real paid subscription (or admin bypass).
 * Kept as a no-op export so existing imports don't break.
 */
export const TrialBootstrap = () => null;
